"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const WidgetQuoteSummary = (props) => {
  const _a = props, { className, size = IconSize.Medium, color = "inherit" } = _a, rest = __objRest(_a, ["className", "size", "color"]);
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    __spreadValues({ width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass }, rest),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        d: "M12 8a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2h-8a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2h-8a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-8Z",
        clipRule: "evenodd",
        opacity: 0.6
      }
    ),
    /* @__PURE__ */ React.createElement("path", { d: "M4.712 18.691V17.03c-1.68-.275-2.829-1.303-3.12-2.949h2.126c.291.874.994 1.268 1.954 1.268.977 0 1.594-.445 1.594-1.217 0-.634-.36-.96-1.251-1.165l-1.68-.412c-1.389-.325-2.503-1.097-2.503-2.794 0-1.611 1.148-2.777 2.88-3V5.2h1.817v1.629c1.509.342 2.4 1.354 2.691 2.76H7.18c-.222-.652-.805-1.15-1.817-1.15-.908 0-1.491.464-1.491 1.167 0 .582.377.908 1.097 1.097l1.783.428c1.594.395 2.571 1.338 2.571 2.88 0 1.663-1.148 2.743-2.794 3.018v1.662H4.712Z" })
  );
};
export default WidgetQuoteSummary;
